import {NameValues} from '@/modules/neodash/model/types/interfaces/NameValue';
import {i18nMixin} from '../../mixins/i18n.mixin';
import {SaleTypeEnum} from '@/modules/neodash/model/types/enums/saleTypeEnum';
import {ITextValue} from '@/interfaces/key-value-interface';

export const allSalesTypes: ITextValue<SaleTypeEnum>[] = [
  {text: 'RetailSales', value: SaleTypeEnum.RetailSales},
  {text: 'DirectSales', value: SaleTypeEnum.DirectSales},
  {text: 'Total', value: SaleTypeEnum.AllOfIt},
];

export const listAllSaleTypes = (types: ITextValue<SaleTypeEnum>[] = allSalesTypes): NameValues =>
    types.map(({text, value}) => ({
      name: i18nMixin.methods.i18n(`Common.${text}`),
      value
    }));

export const listSalesTypes = (...types: SaleTypeEnum[]): NameValues =>
    listAllSaleTypes(allSalesTypes.filter(x => types.some(z => z === x.value)));
